import { CampaignType } from '@dev/ee-api/ee-api-models';
import { WithTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';

export type ScreenType = 'overview' | 'activity' | 'links' | 'geography' | 'AbSplit';

export enum TabNameEnum {
    Activity = 'activity',
    Links = 'links',
    Geography = 'geography',
    Overview = 'overview',
    AbSplit = 'abresults',
}

interface ViewUrlParams {
    type: CampaignType;
    name: string;
    tab: TabNameEnum;
}

export interface CampaignReportProps extends WithTranslation, RouteComponentProps<ViewUrlParams> {}
